import { render } from "./ShopProfile.vue?vue&type=template&id=5581c942&scoped=true"
import script from "./ShopProfile.vue?vue&type=script&lang=js"
export * from "./ShopProfile.vue?vue&type=script&lang=js"

import "./ShopProfile.vue?vue&type=style&index=0&id=5581c942&scoped=true&lang=css"
import "./ShopProfile.vue?vue&type=style&index=1&id=5581c942&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5581c942"]])

export default __exports__